import luupsMockup from "../assets/Luups.png";
import walletMockup from "../assets/Wallet.png";
import creatorBrandMockup from "../assets/CreatorBrand.png";
import endToEndMockup from "../assets/EndToEnd.png";
import searchDiscoveryMockup from "../assets/SearchDiscovery.png";
import loungeCommunityMockup from "../assets/Lounge&Community.png";
import profilesMockup from "../assets/Profiles.png";
import spotlightMockup from "../assets/Spotlight.png";
import builtInMockup from "../assets/Built-In.png";
import CreateChallengesSection from "./CreateChallengesSection";
import StoriesSection from "./StoriesSection";

const PAGE_GUTTER = "max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8";

const rows = [
  {
    id: "luups",
    title: "Luups: content that grows together",
    description: "Build with others, reach new audiences, and earn together.",
    reversed: false,
    bg: "white",
    mockup: luupsMockup,
    textWidth: 611,
    largeType: true,
  },
  {
    id: "payments",
    title: "Payments Built for Underserved Communities",
    description:
      "Earn from gifts and rewards with fast, reliable payouts that work across regions.",
    reversed: true,
    bg: "#F4FAF1",
    mockup: walletMockup,
    textWidth: 570,
    largeType: true,
  },
  {
    id: "collaboration",
    title: "Creator\u2013Brand Collaboration",
    description:
      "Creators and brands find each other directly. No gatekeepers. No exploitative deals.",
    reversed: false,
    bg: "white",
    mockup: creatorBrandMockup,
    textWidth: 662,
    largeType: true,
  },
  {
    id: "chat",
    title: "End-to-End Encrypted Chat",
    description:
      "Secure conversations built for trust. Your messages stay yours.",
    reversed: false,
    bg: "white",
    mockup: endToEndMockup,
    textWidth: 611,
    largeType: true,
  },
  {
    id: "search",
    title: "Search & Discovery",
    description:
      "Find creators, content, and communities that reflect your culture and interests.",
    reversed: true,
    bg: "#F4FAF1",
    mockup: searchDiscoveryMockup,
    textWidth: 570,
    largeType: true,
  },
  {
    id: "lounges",
    title: "Lounges & Communities",
    description:
      "Topic-based spaces to talk, collaborate, and grow beyond likes and follows.",
    reversed: false,
    bg: "white",
    mockup: loungeCommunityMockup,
    textWidth: 611,
    largeType: true,
  },
  {
    id: "profiles",
    title: "Profiles",
    description:
      "Your identity, your story.\nA home for your content, collaborations, and journey as a creator.",
    reversed: true,
    bg: "#BFE8B3",
    mockup: profilesMockup,
    textWidth: 611,
    largeType: true,
  },
  {
    id: "spotlight",
    title: "Spotlight",
    description:
      "High-quality creators get featured not just those with big budgets.",
    reversed: false,
    bg: "white",
    mockup: spotlightMockup,
    textWidth: 611,
    largeType: true,
  },
  {
    id: "editing",
    title: "Built-In Editing Tools",
    description:
      "Simple tools that help your content shine with no expensive software needed.",
    reversed: true,
    bg: "#D8F2CC",
    mockup: builtInMockup,
    textWidth: 570,
    largeType: true,
  },
];

const FeatureBlock = ({
  id,
  title,
  description,
  reversed,
  bg,
  mockup,
  textWidth,
  largeType = false,
}) => {
  const mockupSizeClass = largeType
    ? "max-w-[340px] sm:max-w-[390px] md:max-w-[430px] lg:max-w-[460px] xl:max-w-[500px] 2xl:max-w-[520px]"
    : "max-w-[320px] sm:max-w-[380px] md:max-w-[420px] lg:max-w-[460px] xl:max-w-[500px] 2xl:max-w-[520px]";
  const headingClass = largeType
    ? "text-[38px] leading-[46px] sm:text-[44px] sm:leading-[54px] lg:text-[65px] lg:leading-[80px]"
    : "text-2xl sm:text-3xl lg:text-[30px] lg:leading-tight xl:text-[36px] 2xl:text-[clamp(42px,3vw,62px)]";

  const bodyClass = largeType
    ? "text-lg leading-7 sm:text-xl sm:leading-8 lg:text-[28px] lg:leading-[38px]"
    : "text-sm sm:text-base lg:text-[15px] xl:text-[17px] 2xl:text-[clamp(18px,2vw,26px)] leading-relaxed";

  const textWidthStyle = textWidth ? { maxWidth: `${textWidth}px` } : undefined;
  const phoneWrapClass = "relative";

  return (
    <div style={{ backgroundColor: bg }}>
      <div className={`${PAGE_GUTTER} py-14 md:py-20 lg:py-[100px] xl:py-28 2xl:py-32`}>
        <div
          className={`flex flex-col ${reversed ? "lg:flex-row-reverse" : "lg:flex-row"} items-center gap-10 ${id === "luups" || id === "payments" ? "lg:gap-[50px]" : "lg:gap-12"} xl:gap-16 2xl:gap-20`}
        >
          <div
            className="w-full lg:w-[40%] 2xl:w-[38%] flex flex-col items-center lg:items-start text-center lg:text-left"
            style={textWidthStyle}
          >
            <h3 className={`${headingClass} font-bold text-[#0B0D0B]`}>
              {title}
            </h3>
            <p className={`mt-4 lg:mt-5 ${bodyClass} text-[#0B0D0B] whitespace-pre-line`}>
              {description}
            </p>
          </div>
          <div className={`w-full lg:w-[60%] 2xl:w-[62%] flex justify-center ${phoneWrapClass}`}>
            {mockup ? (
              <img
                src={mockup}
                alt={title}
                className={`w-full ${mockupSizeClass} object-contain`}
              />
            ) : (
              <div
                data-mockup={id}
                className={`w-full ${mockupSizeClass} aspect-[4/5] rounded-3xl bg-gray-100`}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const SolutionSection = () => {
  return (
    <section id="features" className="bg-white overflow-hidden">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 pt-16 md:pt-24 lg:pt-[101px] xl:pt-[108px] 2xl:pt-[116px] pb-6 md:pb-8 lg:pb-10">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-[36px] lg:leading-tight xl:text-[42px] 2xl:text-[clamp(48px,3.5vw,64px)] font-bold leading-tight text-black">
            Our Solution
          </h2>
          <p className="mt-4 lg:mt-4 xl:mt-5 2xl:mt-6 text-sm sm:text-base lg:text-[15px] xl:text-[17px] 2xl:text-[clamp(18px,2vw,26px)] leading-relaxed text-black max-w-[900px] mx-auto">
            Luupli replaces competition with collaboration, opaque algorithms
            with community, and restricted monetization with local-first
            payouts, all inside one platform.
          </p>
        </div>
      </div>
      {rows.slice(0, 3).map((row) => (
        <FeatureBlock key={row.id} {...row} />
      ))}
      <CreateChallengesSection />
      <StoriesSection />
      {rows.slice(3).map((row) => (
        <FeatureBlock key={row.id} {...row} />
      ))}
    </section>
  );
};

export default SolutionSection;
